import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar";
import {
	ALL_PROCESSED_INVOICES_QUERY_KEY,
	processedInvoiceQueries,
} from "~/modules/billing/api/processedInvoice/processedInvoiceQueries.ts";
import type { Invoice } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";
import UpdateInvoicePaymentInformationForm
	from "~/modules/billing/components/InvoiceDetailsView/components/UpdateInvoicePaymentInformationSidebar/UpdateInvoicePaymentInformationForm.tsx";

type Props = {
	invoiceData: Invoice;
	isOpen: boolean;
	onClose: () => void;
};

const UpdateInvoicePaymentInformationSidebar = ({
	invoiceData,
	isOpen,
	onClose,
}: Props) => {

	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		queryClient.invalidateQueries({ queryKey: ALL_PROCESSED_INVOICES_QUERY_KEY });
		await queryClient.refetchQueries({ queryKey: processedInvoiceQueries.details(invoiceData.id).queryKey });

		if (invoiceData.projectId) {
			queryClient.invalidateQueries({ queryKey: processedInvoiceQueries.byProject(invoiceData.projectId).queryKey });
		}
		onClose();
	}, [invoiceData.id, invoiceData.projectId, onClose, queryClient]);


	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={onClose}>
			{isOpen && <UpdateInvoicePaymentInformationForm onCancel={onClose}
															onSuccess={handleSuccess}
															invoiceData={invoiceData} />}
		</Sidebar>
	);
};

export default UpdateInvoicePaymentInformationSidebar;
